export enum CONTRACT_TABS {
  CURRENCY_RATES = 'currencyRates',
  TERMINAL_LINKS = 'terminalLinks',
  TERMINAL_LINKS_CONFIGURATION = 'terminalLinkConfiguration',
  WORKBOOK = 'workbook',
}
